import { UserMeetingStatus } from "../../constants";
import {
  RecallAIBotTranscript,
  UserMeetingShouldBotJoinType,
  UserMeetingType,
} from "../../types/common";

export type MeetingPageMeetingData = {
  id: string;
  calendar_event_id?: string;
  title: string;
  meeting_link?: string;
  start_time: string;
  end_time: string;
  attendee_emails: string[];
  meeting_type: UserMeetingType;
  status: UserMeetingStatus;
  video_url?: string;
  thumbnail_url?: string;
  transcript?: RecallAIBotTranscript;
  meeting_brief?: string;
  should_bot_join?: UserMeetingShouldBotJoinType;
};

export enum MeetingPageTabs {
  NOTE = "note",
  ATTENDEES = "attendees",
  TRANSCRIPT = "transcript",
  OPPORTUNITIES = "opportunities",
}

export enum UserMeetingAttendeeStatus {
  PENDING = "pending",
  INVITED = "invited",
  ACCEPTED = "accepted",
  CANCELLED = "cancelled",
}

export enum UserMeetingAttendeeSource {
  GOOGLE_CALENDAR = "google_calendar",
  OCTOLANE_CRM = "octolane_crm",
}

export type MeetingPageAttendees = {
  id: string;
  name: string;
  email: string;
  is_organizer?: boolean;
  crm_contact_id?: string;
  status: UserMeetingAttendeeStatus;
  source: UserMeetingAttendeeSource;
};
